import { render, staticRenderFns } from "./galleryComponent.vue?vue&type=template&id=28c95a60&scoped=true&"
import script from "./galleryComponent.vue?vue&type=script&lang=js&"
export * from "./galleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./galleryComponent.vue?vue&type=style&index=0&id=28c95a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c95a60",
  null
  
)

export default component.exports